
<template>
  <div class="seviceCont">
    <div class="banner-cont"></div>
    <div class="main-cont part0">
      <title-content :msgObj="titleObj0"></title-content>
      <ul class="flex-lay-row">
        <li v-for="(item, ind) in list0" :key="ind" :class="`item_${ind}`"> 
          <i></i>
          <span>____</span>
          <p>{{item}}</p>
        </li>
      </ul>
    </div>
    <div class="part1">
      <title-content :msgObj="titleObj1" class="main-cont"></title-content>
      <ul class="main-cont flex-lay-row wrap">
        <li v-for="(item, ind) in ~~2" :key="ind" :class="`item_${ind}`"> 
          <p></p>
        </li>
      </ul>
    </div>
    <div class="main-cont flex-lay-row wrap part2">
      <title-content :msgObj="titleObj2"></title-content>
      <div class="img"></div>
    </div>
  </div>
</template>
<script>
export default{
  name: 'aboutUsCont',
  data () {
    return {
      currentIndex: 0,
      titleObj0: {
        title1: '强大的功能支持',
        title2: '帮助您快速构建更稳定、安全的应用，提升运维效率，降低 IT 成本，使您更专注于核心业务创新'
      },
      titleObj1: {
        title1: '智能建站功能介绍',
        title2: '我们拥有具有商业网站工作经验的优秀人才，并及时关注和把我国内外网站开发的更新技术，为客户提供网站规划设计、域名注册、主机托管、网页设计及软件开发、网站宣传、网站维护等一站式全方位服务'
      },
      titleObj2: {
        horizontal: 'left',
        title1: '小程序功能介绍',
        title2: '100＋行业模板直接套用，提供一站式行业解决方案，助力企业打造互联网营销闭环，零技术也可以搞定所有小程序，全球首个开放的小程序，服务平台 致力于开发，者与小程序主提供基于即速应用的各类开放能力及解决方案'
      },
      list0: [
        '低折扣提货，可享受高达8成的官方套餐差价收益', '平台操作简单，十分钟程序可为商户搭建功能丰富', 
        '新型流量入口，内嵌广告收益朋友圈广告代理返点', '总部提供运营方案，代理商为用户提供运营服务支持'
      ]
    }
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.seviceCont{
  .banner-cont{
    background-image: url('../../assets/dawing/ia_200000010.jpg');
  }
  .part0{
    li{
      @extend .flex-lay-column;
      flex: 1;
      i{
        width: .52rem;
        height: .5rem;
        display: block;
        margin-top: .8rem;
        margin-bottom: .2rem;
      }
      p{
        width: 70%;
        margin: .2rem auto;
        text-align: center;
        line-height: .3rem;
        color: #777;
      }
    }
  }
  .part1{
    background: #f8f8f8;
    ul{
      align-items: flex-start;
      li{
        width: 5.2rem;
        padding-top: 1rem;
        p{
          height: 3.2rem;
        }
      }
    }
    /deep/ .subtitle{
      max-width: 90%;
      margin-left: auto;
      margin-right: auto;
    }
  }
  .part2{
    .img{
      width: 40%;
      flex-shrink: 0;
      height: 5.4rem;
      background: url('../../assets/dawing/ia_200000006.png') no-repeat center;
      background-size: contain;
    }
  }
}
@for $i from 0 to 4{
  .part0 .item_#{$i} i{
    background: url('../../assets/dawing/item_icon_#{$i}.png') no-repeat center;
    background-size: contain;
  }
  .part#{$i} {
    padding: 1.3rem 0;
  }
}
@for $i from 0 to 2{
  .part1 .item_#{$i} p{
    background: url('../../assets/dawing/part1_item_#{$i}.png') no-repeat top center;
    background-size: contain;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/DAWNING/serviceProject.vue